import { render, staticRenderFns } from "./Precios.vue?vue&type=template&id=1838ea28&scoped=true&"
import script from "./Precios.vue?vue&type=script&lang=js&"
export * from "./Precios.vue?vue&type=script&lang=js&"
import style0 from "./Precios.vue?vue&type=style&index=0&id=1838ea28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838ea28",
  null
  
)

export default component.exports